import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// パートナー支払単価一覧取得（検索条件でサブテーブル絞り込み）
export async function getIncentiveSaleCompanyPayments(
  id: string,
  filter?: {
    entry_sale_company_name?: string;
    deposit_start_date_start?: string;
    deposit_start_date_end?: string;
  }
) {
  try {
    const path = "incentiveSaleCompanyPayments";
    const params: Record<string, string> = { id };
    if (filter?.entry_sale_company_name)
      params.entry_sale_company_name = filter.entry_sale_company_name;
    if (filter?.deposit_start_date_start)
      params.deposit_start_date_start = filter.deposit_start_date_start;
    if (filter?.deposit_start_date_end)
      params.deposit_start_date_end = filter.deposit_start_date_end;
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 上位店入金単価詳細取得
export async function getIncentiveSaleCompanyPayment(id: string) {
  try {
    const path = "incentiveSaleCompanyPayment";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {}
}
// 上位店入金単価詳細編集
export async function putIncentiveSaleCompanyPayment(editData: EditDataDifine) {
  try {
    const path = "incentiveSaleCompanyPayment";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      payment_method_id: editData.payment_method_id,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 上位店入金単価登録
export async function postIncentiveSaleCompanyPayment(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "incentiveSaleCompanyPayment";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// パートナ支払単価削除
export async function deleteIncentiveSaleCompanyPayment(id: string) {
  try {
    const path = "incentiveSaleCompanyPayment";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
